import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

import { ObjectsViewPhaseProps } from "./ObjectsViewPhase.types"

export default function ObjectsViewPhase(props: ObjectsViewPhaseProps) {
    const { phase, title } = props

    const { setActivePhase, activePhase } = useObjectsView()

    return <ViewBar.Phase phase={phase} title={title} activePhase={activePhase} onPhaseChange={setActivePhase} />
}
